module.exports = "/fonts/vendor/iview/dist/styles/ionicons.ttf?d535a25a79fb1365ae814b61e88fae71";


//////////////////
// WEBPACK FOOTER
// ./node_modules/iview/dist/styles/fonts/ionicons.ttf?v=3.0.0
// module id = 96
// module chunks = 0